import React, { useState } from 'react'
import { FormControl, TextField, Typography } from '@material-ui/core'
import { useContext } from 'react'
import { Context } from '../../../Store'
import { useEffect } from 'react'
import { debounce } from 'lodash'
import { useCallback } from 'react'
import { NumberFormatCustom } from '../../../steps/paymentStep'
import { BookingContext } from '../../../utils/BookingContext'
import { useFormContext } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import TextErrorMessage from '../../../utils/TextErrorMessage'
import { Trans, useTranslation } from 'react-i18next'
import { createUrl } from '../../../utils/createListingUrl'

export const TenantProposalField = () => {
  const { i18n } = useTranslation('translations')
  const [{ property }, dispatch] = useContext(Context)
  const { hasCounteroffer } = useContext(BookingContext)
  const {  errors, setError, clearErrors } = useFormContext()
  const defaultProposal = tenantProposal ?? property.price
  
  const [tenantProposal, setTenantProposal] = useState(defaultProposal)

  useEffect(() => {
    dispatch({ type: 'SET_TENANT_PROPOSAL', payload: tenantProposal })
  }, [tenantProposal, dispatch])

  const debouncedDispatch = useCallback(
    debounce((value) => {
      dispatch({ type: 'SET_TENANT_PROPOSAL', payload: value })
    }, 300),
    [],
  )

  useEffect(() => {
    const minPrice = (parseInt(property.price) / 100) * 75
    if (tenantProposal <= minPrice) {
      setError('tenant_proposal', {
        type: 'manual',
        message: 'min75percentage',
        error_code: 'min75percentage',
      })
    } else {
      clearErrors('tenant_proposal')
    }
  }, [tenantProposal])

  const onChangeTenantProposal = (value) => {
    setTenantProposal(value)
    debouncedDispatch(value)
  }

  return (
    <FormControl fullWidth variant="outlined">
      <TextField
        name="tenant_proposal"
        error={errors.tenant_proposal}
        value={tenantProposal}
        onChange={onChangeTenantProposal}
        variant="outlined"
        fullWidth
        disabled={property.ownerIsPropertyManager || hasCounteroffer}
        InputProps={{
          readOnly: hasCounteroffer,
          inputComponent: NumberFormatCustom,
          inputProps: {
            prefix: '€',
            disabled: property.ownerIsPropertyManager,
          },
          style: { color: 'rgba(117, 117, 117, 0.6)' }, 
        }}
      />
      <ErrorMessage
        errors={errors}
        name="tenant_proposal"
        render={({ message }) => {
          switch (message) {
            case 'min75percentage':
              return (
                <TextErrorMessage>
                  <Typography variant="body2" color="error">
                    <Trans
                      i18nKey="booking.paymentInfo.adviceCost.min75percentage"
                      values={{
                        price: tenantProposal,
                      }}
                      components={{
                        1: (
                          <a
                            href={`${createUrl(i18n.language, property.province, property.city_of_reference)}?price=${
                              tenantProposal
                            }`}
                            style={{ textDecoration: 'underline' }}
                          />
                        ),
                      }}
                    />
                  </Typography>
                </TextErrorMessage>
              )
            default:
              return <TextErrorMessage message={message} />
          }
        }}
      />
    </FormControl>
  )
}
